export * from './IconSlide';
